module.exports = __webpack_public_path__ + "img/FF_Info_Game_11.4c284dba.png";